/*
 * Black November flash sales — landing page state.
 *
 * WHAT THIS DOES NOT DO
 *
 * Today's flash and Up next are rendered by the Flash Sale Countdown app's
 * "Flash sale spotlight" block, placed inside the hero section. That block
 * owns flash selection, live counts and the sold-out flip, and it refreshes
 * itself through the Section Rendering API. Duplicating any of that here
 * would give the page two answers to the same question.
 *
 * So this file covers only what the app does not: the hero countdown, the
 * eight-card schedule strip, Black Friday mode, and the shared "you're
 * subscribed" state across both forms and the sticky bar.
 *
 * WHY JAVASCRIPT AND NOT LIQUID
 *
 * Shopify caches rendered pages, so Liquid's 'now' can be minutes stale — at
 * 10:00:00 on a drop day that is the difference between the right flash and
 * the previous one. Liquid renders a sensible default from the server clock
 * and this corrects it against the visitor's.
 *
 * THE DISCOUNT CODE IS NEVER HERE. The flash_sale_drop entries do carry a
 * discount_code field, which the product-page bar shows while a flash is
 * live. This page must never read it, and the data island below carries
 * drop times and numbers only.
 */
(function () {
  'use strict';

  if (window.bnFlashLoaded) return;
  window.bnFlashLoaded = true;

  /* The mobile bar is position:fixed, because Shopify sections are siblings
     and position:sticky would only hold for the height of its own section.
     Fixed means it floats over the end of the page, so the body gets the
     bar's height back as padding — and loses it again the moment the bar
     goes, on desktop or once the visitor has subscribed. */
  function syncStickySpace() {
    var bar = document.querySelector('[data-bn-sticky]');
    if (!bar) return;
    var shown = window.getComputedStyle(bar).display !== 'none';
    document.body.style.paddingBottom = shown ? bar.offsetHeight + 'px' : '';
  }
  window.addEventListener('resize', syncStickySpace);

  /* <bn-signup> dispatches this on a successful subscribe, and one success
     has to settle both forms and the sticky bar.

     Registered BEFORE the data island check below, deliberately: none of
     this needs flash data, and the band section owns the second form and the
     sticky bar while rendering no island of its own. On a page carrying the
     band without the hero or the schedule, a later registration would leave
     a successful signup with nothing to settle. */
  document.addEventListener('bn-signup:success', function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-bn-flash-page]'),
      function (el) { el.classList.add('bn-fs--subscribed'); }
    );
    syncStickySpace();
  });

  syncStickySpace();

  var tag = document.querySelector('[data-bn-flash-data]');
  if (!tag) return;

  var cfg;
  try {
    cfg = JSON.parse(tag.textContent);
  } catch (e) {
    return;
  }
  /* An EMPTY list is not the same as "nothing is live", so stop rather than
     draw conclusions from it.

     Every loop that reads the schedule is paginated by 250 — this island,
     has_current in bn-flash-hero.liquid, the schedule's island, and the
     app's own spotlight block — and a paginate tag honours a ?page= on the
     request. An inbound link carrying one therefore empties all of them at
     once: the app hides its card and Liquid has already said no flash is
     live, which is the right answer between them. Bailing out keeps it.

     Those loops agreeing on pagination is load-bearing, not incidental. When
     has_current did not paginate it kept insisting a flash was live while
     the app had gone blind and hidden its card, and the hero rendered
     empty. */
  if (!cfg || !cfg.flashes || !cfg.flashes.length) return;

  /* Every section renders its own wrapper — Shopify sections are siblings
     with nothing around them — so page state goes on all of them at once. */
  var roots = document.querySelectorAll('[data-bn-flash-page]');

  function toMs(v) {
    if (v === null || v === undefined || v === '') return NaN;
    if (typeof v === 'number') return v > 0 ? v : NaN;
    if (/^\d+$/.test(v)) return Number(v) > 0 ? Number(v) : NaN;
    return Date.parse(v);
  }

  var flashes = cfg.flashes
    .map(function (f) {
      return {
        number: Number(f.number) || 0,
        at: toMs(f.startsAt),
        end: toMs(f.endsAt),
        limit: Math.max(0, Number(f.limit) || 0),
        hasProduct: f.hasProduct === true
      };
    })
    .filter(function (f) { return !isNaN(f.at); })
    .sort(function (a, b) { return a.at - b.at; });

  var bfAt = toMs(cfg.bfStartAt);

  function pad(n) { return String(n).padStart(2, '0'); }

  function setRootClass(name, on) {
    Array.prototype.forEach.call(roots, function (el) {
      el.classList.toggle(name, !!on);
    });
  }

  /* Positions are never used as flash numbers: a flash with no start time is
     filtered out of `flashes` above, and the numbering need not be dense, so
     the two drift apart the moment either is true. Everything below works in
     flash numbers and returns the flash itself. */
  /* WILL THE APP DRAW A TODAY'S CARD?

     Deliberately the same three tests the app applies: statusOf() in
     flash-spotlight.js needs a start, an end and a usage limit, and the
     block's Liquid skips a drop whose product is not attached yet before it
     builds its own data at all. Miss any one of them and this page either
     covers the app's card with a filler panel or leaves the gap it exists to
     fill, so they are kept identical on purpose. */
  function drawsCard(f, now) {
    return f.limit > 0 && f.hasProduct && !isNaN(f.end) && f.at <= now && now < f.end;
  }

  function appCardFlash(now) {
    var found = null;
    for (var i = 0; i < flashes.length; i++) {
      if (drawsCard(flashes[i], now)) found = flashes[i];
    }
    return found;
  }

  /* WHICH CHIP THE SCHEDULE CALLS TODAY'S — a looser question, and
     deliberately so. A flash that is missing an end time or a usage limit is
     still the one that most recently dropped, and the strip should say that
     rather than mark it sold out the instant it starts. */
  function activeFlash(now) {
    var found = null;
    for (var i = 0; i < flashes.length; i++) {
      var f = flashes[i];
      if (f.at > now) continue;
      if (!isNaN(f.end) && now > f.end) continue;
      found = f;
    }
    return found;
  }

  /* The next announced drop — loose, like activeFlash and for the same
     reason. This drives the countdown, the "Flash 0N drops…" label in three
     places, and the strip's up-next chip, all of which describe the schedule
     the page itself publishes. A date with no product attached yet is still
     a date, and a countdown to it is still correct; only the question of
     whether the APP is drawing a card needs the app's exact test. */
  function nextFlash(now) {
    for (var i = 0; i < flashes.length; i++) {
      if (flashes[i].at > now) return flashes[i];
    }
    return null;
  }

  function hasStarted(number, now) {
    for (var i = 0; i < flashes.length; i++) {
      if (flashes[i].number === number) return flashes[i].at <= now;
    }
    return false;
  }

  function isBf(now) { return !isNaN(bfAt) && now >= bfAt; }

  /* ------------------------------------------------------------ schedule - */

  /* Past flashes are sold out by definition. Today's follows the sold flag
     Liquid stamped on the chip, refreshed by reRenderSchedule below. The
     rest stay locked. Every width and colour is CSS keyed off these classes. */
  function renderSchedule(now) {
    var reel = document.querySelector('[data-bn-reel]');
    var t = reel ? reel.dataset : {};
    var active = activeFlash(now);
    var next = nextFlash(now);
    var cards = document.querySelectorAll('[data-bn-number]');
    Array.prototype.forEach.call(cards, function (card) {
      var number = Number(card.getAttribute('data-bn-number'));
      var isFocus = !!active && number === active.number;
      var isDone = !isFocus && hasStarted(number, now);
      var isNext = !!next && number === next.number;
      var sold = isFocus && card.getAttribute('data-bn-sold') === 'true';
      var day = card.getAttribute('data-bn-day') || '';

      card.classList.toggle('is-done', isDone);
      card.classList.toggle('is-focus', isFocus);
      card.classList.toggle('is-next', isNext);
      card.classList.toggle('is-locked', !isFocus && !isDone);
      card.classList.toggle('is-sold-out', sold);

      var status = card.querySelector('[data-bn-status]');
      if (!status) return;
      if (isDone) status.textContent = (t.tSoldOut || '');
      else if (isFocus) status.textContent = sold ? (t.tTodaySold || '') : (t.tTodayLive || '');
      else if (isNext) status.textContent = (t.tUpNext || '').replace('%day%', day);
      else status.textContent = (t.tDrops || '').replace('%day%', day);
    });
  }

  /* Centre today's card in the mobile swipe strip. Once per change of active
     flash — not on every countdown tick, which would fight the visitor's
     own scrolling. */
  function centreSchedule() {
    var reel = document.querySelector('[data-bn-reel]');
    if (!reel) return;
    var focus = reel.querySelector('.is-focus');
    if (!focus) return;
    requestAnimationFrame(function () {
      var offset = focus.offsetLeft - reel.offsetLeft;
      reel.scrollLeft = Math.max(0, offset - (reel.clientWidth - focus.offsetWidth) / 2);
    });
  }

  /* Ask Shopify to re-render just the schedule section, the same trick the
     app's own blocks use, so today's chip can flip to sold out without a
     reload. Drops ?page= for the same reason the app does: it is shared
     with paginated grids elsewhere on the page. */
  function reRenderSchedule() {
    var section = document.querySelector('[data-bn-schedule-section]');
    if (!section) return;
    var id = section.getAttribute('data-bn-schedule-section');
    if (!id) return;

    var params = String(window.location.search || '')
      .replace(/^\?/, '')
      .split('&')
      .filter(function (p) { return p && !/^(page|section_id|bn_flash)=/.test(p); });
    params.push('section_id=' + encodeURIComponent(id), 'bn_flash=' + Date.now());

    fetch(window.location.pathname + '?' + params.join('&'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var next = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-bn-reel]');
        var current = section.querySelector('[data-bn-reel]');
        if (!next || !current) return;
        /* Keep the visitor's scroll position across the swap. */
        var left = current.scrollLeft;
        current.innerHTML = next.innerHTML;
        current.scrollLeft = left;
        renderSchedule(Date.now());
      })
      .catch(function () { /* leave the current state alone */ });
  }

  /* --------------------------------------------------------- countdown --- */

  function countdownTarget(now) {
    var next = nextFlash(now);
    if (next) return next.at;
    if (isNaN(bfAt) || bfAt <= now) return null;
    return bfAt;
  }

  function renderCountdown(target) {
    var boxes = document.querySelectorAll('[data-bn-countdown]');
    if (!boxes.length) return;
    if (target == null) {
      Array.prototype.forEach.call(boxes, function (b) { b.hidden = true; });
      return;
    }
    var secs = Math.max(0, Math.floor((target - Date.now()) / 1000));
    var parts = {
      d: pad(Math.floor(secs / 86400)),
      h: pad(Math.floor((secs % 86400) / 3600)),
      m: pad(Math.floor((secs % 3600) / 60)),
      s: pad(secs % 60)
    };
    Array.prototype.forEach.call(boxes, function (box) {
      box.hidden = false;
      Object.keys(parts).forEach(function (k) {
        var el = box.querySelector('[data-bn-cd="' + k + '"]');
        if (el && el.textContent !== parts[k]) el.textContent = parts[k];
      });
    });
  }

  /* Three of these: the hero's label, the filler panel's, and the sticky
     bar's kicker. Only one of the first two is ever visible at a time. */
  function renderNextLabel(now) {
    var next = nextFlash(now);
    var bfToCome = !isNaN(bfAt) && bfAt > now;
    Array.prototype.forEach.call(document.querySelectorAll('[data-bn-next-label]'), function (el) {
      if (next) el.textContent = (el.dataset.tNext || '').replace('%number%', pad(next.number));
      else el.textContent = bfToCome ? (el.dataset.tBf || '') : '';
    });
  }

  /* ------------------------------------------------------------- paint --- */

  var lastNumber = null;
  var lastBf = null;
  var lastNoLive = null;

  function activeNumber(now) {
    var a = activeFlash(now);
    return a ? a.number : 0;
  }

  function paint(firstRun) {
    var now = Date.now();
    var bf = isBf(now);
    var number = activeNumber(now);

    /* No card from the app right now — before the first drop, and in every
       gap between a flash ending and the next one starting. */
    var noLive = !appCardFlash(now);

    setRootClass('bn-fs--bf', bf);
    setRootClass('bn-fs--no-live', noLive);

    renderSchedule(now);
    renderNextLabel(now);
    renderCountdown(countdownTarget(now));

    var changed = number !== lastNumber || bf !== lastBf || noLive !== lastNoLive;
    lastNumber = number;
    lastBf = bf;
    lastNoLive = noLive;

    /* On the very first paint the server has just rendered this state, so
       re-fetching it immediately would be one wasted cache-busting request
       per page view. Only a change after load is worth a refresh. */
    if (changed && !firstRun) {
      centreSchedule();
      reRenderSchedule();
    }
  }

  paint(true);
  centreSchedule();
  syncStickySpace();

  setInterval(function () {
    var now = Date.now();
    renderCountdown(countdownTarget(now));
    /* A drop boundary only matters once a second has carried us past it. */
    if (activeNumber(now) !== lastNumber || isBf(now) !== lastBf || !appCardFlash(now) !== lastNoLive) paint(false);
  }, 1000);

  var poll = Math.max(15, Number(cfg.pollSeconds) || 60) * 1000;
  setInterval(reRenderSchedule, poll);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reRenderSchedule();
  });
})();
